<template>
  <v-app id="register-project-user-view">
    <v-content>
      <transition mode="out-in">
        <router-view />
      </transition>
    </v-content>
  </v-app>
</template>

<script>
export default {}
</script>

<style></style>
